import React, { useEffect, useState } from 'react';

interface PeerContentTileProps {
  title: string;
  needsAttention: boolean;
  /** When set and needsAttention, shown instead of the default "Needs review". */
  attentionSummary?: string;
  summaryWhenOk: string;
  peerId: number;
  children: React.ReactNode;
}

const PeerContentTile: React.FC<PeerContentTileProps> = ({
  title,
  needsAttention,
  attentionSummary,
  summaryWhenOk,
  peerId,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(() => needsAttention);

  useEffect(() => {
    setIsOpen(needsAttention);
  }, [peerId, needsAttention]);

  const summaryText = needsAttention ? attentionSummary ?? 'Needs review' : summaryWhenOk;
  const summaryEmphasized = needsAttention && !isOpen;
  const summaryClassName = summaryEmphasized ? 'text-sm font-semibold text-red' : 'text-sm text-gray-600';

  return (
    <div className="h-fit w-full self-start rounded-lg border border-gray-300 bg-white">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-2 p-3 text-left hover:bg-gray-50"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <h4 className="text-sm font-semibold text-gray-900">{title}</h4>
        <div className="flex shrink-0 items-center gap-2">
          <span className={summaryClassName}>{summaryText}</span>
          <svg
            className={`h-5 w-5 shrink-0 transform transition-transform ${isOpen ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>
      <div className="min-w-0 border-t border-gray-200 p-4" hidden={!isOpen}>
        {children}
      </div>
    </div>
  );
};

export default PeerContentTile;
